import { PortalConfigurationType } from '@trnsact/trnsact-shared-types';
import { tiersDefaultConfig } from '../internalCreditTiers/constants';
import { recertificationDefaultConfig } from '../recertification/constants';
import { voNotificationsDefaultConfig } from '../notificationsManagement/constants';

export const defaultConfigByType: Partial<Record<PortalConfigurationType, Record<string, any>>> = {
  [PortalConfigurationType.VoNotifications]: voNotificationsDefaultConfig,
  [PortalConfigurationType.Recertification]: recertificationDefaultConfig,
  [PortalConfigurationType.InternalCreditTiers]: tiersDefaultConfig,
};
